import React, { useState } from 'react';
import {
  Typography,
  Grid,
  Box,
  CircularProgress,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Pagination,
  Stack,
} from '@mui/material';
import ConversationCard from '../components/ConversationCard';
import { useConversations } from '../hooks/useConversations';

const ConversationListPage = () => {
  const [status, setStatus] = useState('all');
  const [sortBy, setSortBy] = useState('createdAt:desc');
  const [page, setPage] = useState(1);
  const [limit] = useState(10);

  const filters = {
    ...(status !== 'all' && { status }),
  };

  const options = {
    page,
    limit,
    sortBy,
  };

  const { conversations, totalPages, isLoading, error } = useConversations(filters, options);

  const handleStatusChange = (event) => {
    setStatus(event.target.value);
    setPage(1);
  };

  const handleSortChange = (event) => {
    setSortBy(event.target.value);
    setPage(1);
  };

  const handlePageChange = (event, value) => {
    setPage(value);
  };

  if (isLoading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight="200px">
        <CircularProgress />
      </Box>
    );
  }

  if (error) {
    const errorMessage = typeof error === 'object' && error !== null ? error.message : 'Tuntematon virhe';
    return (
      <Typography color="error">
        Virhe ladattaessa keskusteluja: {errorMessage}
      </Typography>
    );
  }

  return (
    <Box>
      <Typography variant="h4" sx={{ mb: 3 }}>
        Keskustelut
      </Typography>

      <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2} sx={{ mb: 3 }}>
        <FormControl sx={{ minWidth: 200 }}>
          <InputLabel>Tila</InputLabel>
          <Select value={status} onChange={handleStatusChange} label="Tila">
            <MenuItem value="all">Kaikki</MenuItem>
            <MenuItem value="active">Aktiiviset</MenuItem>
            <MenuItem value="completed">Valmiit</MenuItem>
          </Select>
        </FormControl>
        <FormControl sx={{ minWidth: 200 }}>
          <InputLabel>Järjestys</InputLabel>
          <Select value={sortBy} onChange={handleSortChange} label="Järjestys">
            <MenuItem value="createdAt:desc">Uusimmat ensin</MenuItem>
            <MenuItem value="createdAt:asc">Vanhimmat ensin</MenuItem>
            <MenuItem value="updatedAt:desc">Viimeksi päivitetyt</MenuItem>
            <MenuItem value="updatedAt:asc">Vanhimmin päivitetyt</MenuItem>
          </Select>
        </FormControl>
      </Stack>

      <Grid container spacing={3}>
        {conversations.map((conversation) => (
          <Grid item xs={12} md={6} lg={4} key={conversation.id || conversation._id}>
            <ConversationCard conversation={conversation} />
          </Grid>
        ))}
        {conversations.length === 0 && (
          <Grid item xs={12}>
            <Typography variant="body1" color="text.secondary">
              Ei keskusteluja valituilla hakuehdoilla.
            </Typography>
          </Grid>
        )}
      </Grid>

      {totalPages > 1 && (
        <Box sx={{ mt: 4, display: 'flex', justifyContent: 'center' }}>
          <Pagination count={totalPages} page={page} onChange={handlePageChange} color="primary" />
        </Box>
      )}
    </Box>
  );
};

export default ConversationListPage; 